export const DAO_CODE = 'REFERENCE' + '_DAO';
